export default "__VITE_ASSET__YUnEtVM5__"